import { WorkflowDefinition } from "../common/controls/workflowRoadmapTypes";

export const showcaseWorkflow: WorkflowDefinition = {
  id: "ShowcaseWorkflow",
  initialState: "pending",
  mainPath: ["inReview", "approved", "closed"],
  nodes: [{ id: "inReview" }, { id: "approved" }, { id: "closed" }],
  transitions: [
    { from: "pending", to: "inReview", id: "submit" },
    { from: "inReview", to: "approved", id: "approve" },
    { from: "inReview", to: "rejected", id: "reject" },
    { from: "inReview", to: "failed", id: "fail" },
    { from: "failed", to: "inReview", id: "retry" },
    { from: "approved", to: "closed", id: "close" },
    { from: "rejected", to: "pending", id: "reopen" },
  ],
  stateAnchors: {
    rejected: { afterIndex: 0, towardIndex: 1, kind: "error" },
    failed: { afterIndex: 0, towardIndex: 1, kind: "error" },
  },
  branchFrom: null,
};

export const SHOWCASE_WORKFLOW_ERROR_STATES: string[] = [
  "pending",
  "rejected",
  "failed",
];

export const SHOWCASE_WORKFLOW_AWAITING_STATES: Record<
  string,
  Record<string, { s: string }>
> = {};

export const SHOWCASE_WORKFLOW_FORWARD_TRANSITIONS: string[] = [
  "approve",
  "close",
];

export const editionDocumentationWorkflow: WorkflowDefinition = {
  id: "EditionDocumentationWorkflow",
  initialState: "noDocumentation",
  mainPath: ["docsGenerated", "sentForSignature", "esperandoFirmaDjct"],
  nodes: [
    { id: "docsGenerated" },
    { id: "sentForSignature" },
    { id: "esperandoFirmaDjct" },
  ],
  transitions: [
    {
      from: "noDocumentation",
      to: "generatingDocs",
      id: "generateDocumentation",
    },
    {
      from: "sentForSignature",
      to: "noDocumentation",
      id: "deleteAndRestartFromSignature",
    },
    { from: "generatingDocs", to: "docsGenerated", id: "completeGeneration" },
    { from: "generatingDocs", to: "generationFailed", id: "failGeneration" },
    { from: "generatingDocs", to: "noDocumentation", id: "cancelGeneration" },
    {
      from: "docsGenerated",
      to: "noDocumentation",
      id: "deleteAndRestartFromGenerated",
    },
    {
      from: "generationFailed",
      to: "noDocumentation",
      id: "deleteAndRestartFromFailed",
    },
    {
      from: "generationFailed",
      to: "generatingDocs",
      id: "retryGenerateDocumentation",
    },
    {
      from: "docsGenerated",
      to: "sendingForSignature",
      id: "sendForSignature",
    },
    {
      from: "sendingForSignature",
      to: "sentForSignature",
      id: "completeSending",
    },
    {
      from: "sendingForSignature",
      to: "signatureSendingFailed",
      id: "failSending",
    },
    { from: "sendingForSignature", to: "docsGenerated", id: "cancelSending" },
    {
      from: "signatureSendingFailed",
      to: "sendingForSignature",
      id: "retrySendForSignature",
    },
    {
      from: "signatureSendingFailed",
      to: "docsGenerated",
      id: "backToDocsFromSignatureFailed",
    },
    { from: "sentForSignature", to: "falloDeFirmas", id: "falloFirmas" },
    {
      from: "falloDeFirmas",
      to: "noDocumentation",
      id: "borrarDocumentacionFromFallo",
    },
    {
      from: "sentForSignature",
      to: "generandoEjemplarEdicion",
      id: "iniciarCierreFirmas",
    },
    {
      from: "generandoEjemplarEdicion",
      to: "esperandoFirmaDjct",
      id: "completarCierreFirmas",
    },
    {
      from: "generandoEjemplarEdicion",
      to: "falloGeneracionEjemplar",
      id: "fallarCierreFirmas",
    },
    {
      from: "falloGeneracionEjemplar",
      to: "generandoEjemplarEdicion",
      id: "reintentarCierreFirmas",
    },
    { from: "esperandoFirmaDjct", to: "falloDeFirmas", id: "falloFirmasDjct" },
    {
      from: "esperandoFirmaDjct",
      to: "noDocumentation",
      id: "borrarDocumentacionDesdeEsperaDjct",
    },
    {
      from: "falloGeneracionEjemplar",
      to: "noDocumentation",
      id: "borrarDocumentacionDesdeFalloEjemplar",
    },
  ],
  stateAnchors: {
    generatingDocs: { afterIndex: -1, towardIndex: 0, kind: "transient" },
    generationFailed: { afterIndex: -1, towardIndex: 0, kind: "error" },
    sendingForSignature: { afterIndex: 0, towardIndex: 1, kind: "transient" },
    signatureSendingFailed: { afterIndex: 0, towardIndex: 1, kind: "error" },
    generandoEjemplarEdicion: {
      afterIndex: 1,
      towardIndex: 2,
      kind: "transient",
    },
    falloGeneracionEjemplar: { afterIndex: 1, towardIndex: 2, kind: "error" },
    falloDeFirmas: { afterIndex: 1, towardIndex: 2, kind: "error" },
  },
  branchFrom: null,
};

export const EDITION_DOCUMENTATION_WORKFLOW_ERROR_STATES: string[] = [
  "noDocumentation",
  "generatingDocs",
  "generationFailed",
  "sendingForSignature",
  "signatureSendingFailed",
  "generandoEjemplarEdicion",
  "falloGeneracionEjemplar",
  "falloDeFirmas",
];

export const EDITION_DOCUMENTATION_WORKFLOW_AWAITING_STATES: Record<
  string,
  Record<string, { s: string }>
> = {};

export const EDITION_DOCUMENTATION_WORKFLOW_FORWARD_TRANSITIONS: string[] = [
  "sendForSignature",
  "iniciarCierreFirmas",
];

export const signedEditionDndaWorkflow: WorkflowDefinition = {
  id: "SignedEditionDndaWorkflow",
  initialState: "contratosFirmados",
  mainPath: [
    "contratosFirmados",
    "ejemplarGenerado",
    "dndaRegistrado",
    "ejemplarHabilitadoUpload",
    "ejemplarSubido",
    "comprobanteRecibido",
  ],
  nodes: [
    { id: "contratosFirmados" },
    { id: "ejemplarGenerado" },
    { id: "dndaRegistrado" },
    { id: "ejemplarHabilitadoUpload" },
    { id: "ejemplarSubido" },
    { id: "comprobanteRecibido" },
  ],
  transitions: [
    {
      from: "contratosFirmados",
      to: "generandoEjemplar",
      id: "iniciarGeneracionEjemplar",
    },
    {
      from: "generandoEjemplar",
      to: "ejemplarGenerado",
      id: "completarGeneracionEjemplar",
    },
    {
      from: "ejemplarGenerado",
      to: "registrandoDnda",
      id: "iniciarRegistroDnda",
    },
    {
      from: "registrandoDnda",
      to: "dndaRegistrado",
      id: "completarRegistroDnda",
    },
    {
      from: "dndaRegistrado",
      to: "ejemplarHabilitadoUpload",
      id: "recibirHabilitacionUpload",
    },
    {
      from: "ejemplarHabilitadoUpload",
      to: "subiendoEjemplar",
      id: "iniciarUploadEjemplar",
    },
    {
      from: "subiendoEjemplar",
      to: "ejemplarSubido",
      id: "completarUploadEjemplar",
    },
    {
      from: "ejemplarSubido",
      to: "comprobanteRecibido",
      id: "descargarComprobanteDnda",
    },
    {
      from: "generandoEjemplar",
      to: "ejemplarGeneracionFallida",
      id: "fallarGeneracionEjemplar",
    },
    {
      from: "registrandoDnda",
      to: "registroDndaFallido",
      id: "fallarRegistroDnda",
    },
    {
      from: "subiendoEjemplar",
      to: "uploadFallido",
      id: "fallarUploadEjemplar",
    },
    {
      from: "ejemplarGenerado",
      to: "registroDndaFallido",
      id: "fallarInicioRegistroDnda",
    },
    {
      from: "dndaRegistrado",
      to: "uploadFallido",
      id: "fallarInicioUploadDesdeRegistrado",
    },
    {
      from: "ejemplarHabilitadoUpload",
      to: "uploadFallido",
      id: "fallarInicioUploadDesdeHabilitado",
    },
    {
      from: "registrandoDnda",
      to: "registroAvanceFallido",
      id: "fallarAvanceRegistro",
    },
    {
      from: "subiendoEjemplar",
      to: "uploadAvanceFallido",
      id: "fallarAvanceUpload",
    },
    {
      from: "uploadFallido",
      to: "registrandoDnda",
      id: "expirarUploadKeyDuranteUpload",
    },
    {
      from: "ejemplarGeneracionFallida",
      to: "generandoEjemplar",
      id: "reintentarGeneracionEjemplar",
    },
    {
      from: "registroDndaFallido",
      to: "registrandoDnda",
      id: "reintentarRegistroDnda",
    },
    {
      from: "uploadFallido",
      to: "subiendoEjemplar",
      id: "reintentarUploadEjemplar",
    },
    {
      from: "registroAvanceFallido",
      to: "dndaRegistrado",
      id: "reintentarAvanceRegistro",
    },
    {
      from: "uploadAvanceFallido",
      to: "ejemplarSubido",
      id: "reintentarAvanceUpload",
    },
  ],
  stateAnchors: {
    generandoEjemplar: { afterIndex: 0, towardIndex: 1, kind: "transient" },
    registrandoDnda: { afterIndex: 1, towardIndex: 2, kind: "transient" },
    subiendoEjemplar: { afterIndex: 3, towardIndex: 4, kind: "transient" },
    ejemplarGeneracionFallida: { afterIndex: 0, towardIndex: 1, kind: "error" },
    registroDndaFallido: { afterIndex: 1, towardIndex: 2, kind: "error" },
    uploadFallido: { afterIndex: 3, towardIndex: 4, kind: "error" },
    registroAvanceFallido: { afterIndex: 1, towardIndex: 2, kind: "error" },
    uploadAvanceFallido: { afterIndex: 3, towardIndex: 4, kind: "error" },
  },
  branchFrom: null,
};

export const SIGNED_EDITION_DNDA_WORKFLOW_ERROR_STATES: string[] = [
  "generandoEjemplar",
  "registrandoDnda",
  "subiendoEjemplar",
  "ejemplarGeneracionFallida",
  "registroDndaFallido",
  "uploadFallido",
  "registroAvanceFallido",
  "uploadAvanceFallido",
];

export const SIGNED_EDITION_DNDA_WORKFLOW_AWAITING_STATES: Record<
  string,
  Record<string, { s: string }>
> = {
  dndaRegistrado: {
    es: {
      s: "el email de habilitación de la DNDA, que levanta el lector de correo",
    },
    en: { s: "the DNDA enabling email, picked up by the mail poller" },
    pt: { s: "o email de habilitação da DNDA, lido pelo leitor de correio" },
  },
  ejemplarSubido: {
    es: {
      s: "el scheduler que busca el comprobante en el portal de la DNDA (puede tardar meses)",
    },
    en: {
      s: "the scheduler polling the DNDA portal for the certificate (may take months)",
    },
    pt: {
      s: "o scheduler que busca o comprovante no portal da DNDA (pode levar meses)",
    },
  },
};

export const SIGNED_EDITION_DNDA_WORKFLOW_FORWARD_TRANSITIONS: string[] = [
  "iniciarGeneracionEjemplar",
  "iniciarRegistroDnda",
  "recibirHabilitacionUpload",
  "iniciarUploadEjemplar",
  "descargarComprobanteDnda",
];

export const signedEditionSadaicWorkflow: WorkflowDefinition = {
  id: "SignedEditionSadaicWorkflow",
  initialState: "contratosFirmados",
  mainPath: ["sadaicEnTramite", "sadaicPublicado"],
  nodes: [{ id: "sadaicEnTramite" }, { id: "sadaicPublicado" }],
  transitions: [
    {
      from: "contratosFirmados",
      to: "subiendoSadaic",
      id: "iniciarSubidaSadaic",
    },
    {
      from: "subiendoSadaic",
      to: "sadaicEnTramite",
      id: "completarSubidaSadaic",
    },
    {
      from: "subiendoSadaic",
      to: "subidaSadaicFallida",
      id: "fallarSubidaSadaic",
    },
    {
      from: "contratosFirmados",
      to: "subidaSadaicFallida",
      id: "fallarInicioSadaic",
    },
    {
      from: "subidaSadaicFallida",
      to: "subiendoSadaic",
      id: "reintentarSubidaSadaic",
    },
    {
      from: "sadaicEnTramite",
      to: "sadaicPublicado",
      id: "confirmarPublicacionSadaic",
    },
  ],
  stateAnchors: {
    subiendoSadaic: { afterIndex: -1, towardIndex: 0, kind: "transient" },
    subidaSadaicFallida: { afterIndex: -1, towardIndex: 0, kind: "error" },
  },
  branchFrom: {
    workflow: "SignedEditionDndaWorkflow",
    state: "ejemplarSubido",
    description: {
      es: {
        s: "Una vez realizada la entrega digital de la edición en la DNDA, comienza el proceso de entrega de documentación a SADAIC.",
      },
      en: {
        s: "Once the edition's digital delivery to DNDA is completed, the SADAIC documentation delivery process begins.",
      },
      pt: {
        s: "Uma vez realizada a entrega digital da edição na DNDA, começa o processo de entrega de documentação à SADAIC.",
      },
    },
  },
};

export const SIGNED_EDITION_SADAIC_WORKFLOW_ERROR_STATES: string[] = [
  "contratosFirmados",
  "subiendoSadaic",
  "subidaSadaicFallida",
];

export const SIGNED_EDITION_SADAIC_WORKFLOW_AWAITING_STATES: Record<
  string,
  Record<string, { s: string }>
> = {};

export const SIGNED_EDITION_SADAIC_WORKFLOW_FORWARD_TRANSITIONS: string[] = [
  "confirmarPublicacionSadaic",
];
